// src/data/storyStages.js — the four stages of the core modules, shared by
// the home page and the modules page so both draw the path the same way.
// Accent per stage: text colour, marker colour and the tint behind an emoji.
export const STORY_STAGES = [
  {
    level: 'Foundation',
    blurb: 'Why family stories matter, how to find them, and what makes one worth retelling.',
    text: 'text-thread-sand',
    node: 'bg-thread-sand',
    tint: 'bg-thread-sand/10 ring-thread-sand/30',
  },
  {
    level: 'Application',
    blurb: 'Getting conversations started at home, telling stories across generations, and starting traditions.',
    text: 'text-thread-glow',
    node: 'bg-thread-glow',
    tint: 'bg-thread-glow/10 ring-thread-glow/30',
  },
  {
    level: 'Advanced',
    blurb: 'What to do when a family story is about conflict, loss or mental health.',
    text: 'text-thread-flame',
    node: 'bg-thread-flame',
    tint: 'bg-thread-flame/10 ring-thread-flame/30',
  },
  {
    level: 'Mastery',
    blurb: "Helping other people find and tell their own family's stories.",
    text: 'text-thread-gold',
    node: 'bg-thread-gold',
    tint: 'bg-thread-gold/10 ring-thread-gold/30',
  },
];
